// This file is auto-generated by scripts/set-env.js
// Do not edit manually - changes will be overwritten

export const environment = {
  production: false,
  urlApi: 'https://apiteste.tennistool.tenisintegrado.com/',
  identifySystem: '2',
  urlDupr: 'https://uat.dupr.gg/',
  clientKeyDupr: 'test-ck-41fc33c3-6d8c-4656-fe74-9193387afb2c',
  googleAPIKey: 'AIzaSyCyKsD93pgDGV3FTia70GCZqso-MxdaTww',
};
